import { useState, useContext } from "react";
import FormInput from "../../../../../components/Form/FormInput";
import FormSelect from "../../../../../components/Form/FormSelect";
import CheckboxField from "../../../../../components/Form/CheckboxField";
import { getTimezonesWithOffset } from "../../../../../utils/constants/timezones";
import { AuthContext } from "../../../../../context/AuthContext";
import { isFreelance } from "../../../../../utils/constants/accountType";
import { btn } from "../../../../../components/Button/buttonStyles";

const genders = ["Male", "Female", "Other"];
const staticTimezones = getTimezonesWithOffset();

const PrimaryUserEditForm = ({ client, onCancel, onSave }) => {
  const primaryUser = client?.primary_user || {};
  const { user } = useContext(AuthContext);
  // Freelance accounts cannot grant clients access to the client portal.
  const freelance = isFreelance(user);

  const [form, setForm] = useState({
    first_name: primaryUser?.first_name || "",
    last_name: primaryUser?.last_name || "",
    phone: primaryUser?.phone || "",
    timezone: primaryUser?.timezone || "",
    teams_id: primaryUser?.teams_id || "",
    zoom_id: primaryUser?.zoom_id || "",
    gender: primaryUser?.gender || "",
    nationality: primaryUser?.nationality || "",
    can_login: client?.can_login || false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    const currentErrors = {};
    if (!form.first_name) currentErrors.first_name = "First name is required.";
    if (!form.last_name) currentErrors.last_name = "Last name is required.";
    if (!form.timezone) currentErrors.timezone = "Timezone is required.";
    setErrors(currentErrors);
    return Object.keys(currentErrors).length === 0;
  };

  const requiredFields = [
    "first_name",
    "last_name",
    "email",
    "timezone",
  ];

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let errorMsg = "";
    if (
      (name === "company_name" && form.type === "Company" && !value) ||
      (requiredFields.includes(name) && !value)
    ) {
      errorMsg =
        name === "email"
          ? "Email is required."
          : `${name.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())} is required.`;
    }
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onSave(freelance ? { ...form, can_login: false } : form);
  };

  return (
    <div>
      <div className="mb-5">
        <h2 className="text-xl font-bold text-gray-900">Edit Primary User</h2>
      </div>
    <form
      onSubmit={handleSubmit}
      className="bg-white shadow-sm border border-gray-100 rounded-lg p-5 space-y-5"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-4 items-start">
        <FormInput
          label="First Name"
          name="first_name"
          value={form.first_name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.first_name}
          required
        />

        <FormInput
          label="Last Name"
          name="last_name"
          value={form.last_name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.last_name}
          required
        />

        <FormSelect
          label="Timezone"
          name="timezone"
          value={form.timezone}
          onChange={handleChange}
          onBlur={handleBlur}
          options={staticTimezones}
          error={errors.timezone}
          required
        />

        <FormSelect
          label="Gender"
          name="gender"
          value={form.gender}
          onChange={handleChange}
          options={genders}
          error={errors.gender}
        />

        <FormInput
          label="Phone"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.phone}
        />

        <FormInput
          label="Zoom ID"
          name="zoom_id"
          value={form.zoom_id}
          onChange={handleChange}
        />

         <FormInput
          label="Teams ID"
          name="teams_id"
          value={form.teams_id}
          onChange={handleChange}
        />

        <FormInput
          label="Nationality"
          name="nationality"
          value={form.nationality}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors.nationality}
        />
      </div>

      {!freelance && (
        <CheckboxField
          label="Can Login"
          name="can_login"
          checked={form.can_login}
          onChange={handleChange}
        />
      )}

      <div className="pt-3 border-t border-gray-100 space-y-3">
        <span className="block text-xs text-gray-500">
          Fields marked with <span className="text-danger-500">*</span> are mandatory.
        </span>
        <div className="flex gap-2 text-sm">
          <button
            type="submit"
            className={btn("primary", "sm")}
          >
            Save
          </button>
          <button
            type="button"
            onClick={onCancel}
            className={btn("secondary", "sm")}
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
    </div>
  );
};

export default PrimaryUserEditForm;
